import React from 'react';

import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import S from './styles';

function Footer() {
  return (
    <S.Footer>
      <S.Text>
        &copy; { new Date().getFullYear()} e-Auditoria. Todos os direitos reservados.
      </S.Text>

      <S.Social>
        <S.SocialLink
          href="https://facebook.com/eauditoriasaas"
          rel="noopener noreferrer"
          target="_blank"
        >
          <FontAwesomeIcon icon={faFacebookF} size="lg" />
        </S.SocialLink>
        <S.SocialLink
          href="https://twitter.com/e_auditoria"
          rel="noopener noreferrer"
          target="_blank"
        >
          <FontAwesomeIcon icon={faTwitter} size="lg" />
        </S.SocialLink>
        <S.SocialLink
          href="https://linkedin.com/company/eauditoria"
          rel="noopener noreferrer"
          target="_blank"
        >
          <FontAwesomeIcon icon={faLinkedinIn} size="lg" />
        </S.SocialLink>
        <S.SocialLink
          href="https://youtube.com/user/eauditoria"
          rel="noopener noreferrer"
          target="_blank"
        >
          <FontAwesomeIcon icon={faYoutube} size="lg" />
        </S.SocialLink>
        <S.SocialLink
          href="http://www.e-auditoria.com.br"
          rel="noopener noreferrer"
          target="_blank"
        >
          <S.Img
            src="https://images.e-auditoria.com.br/global/logos/png/e-auditoria-white.png"
            alt="e-Auditoria"
          />
        </S.SocialLink>
      </S.Social>
    </S.Footer>
  );
}

export default Footer;
